let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aFUSO")).then(() => parcelRequire('8Cf2W'));